// extracted by mini-css-extract-plugin
module.exports = {"trigger":"style_trigger__sIPN0","colorPanel":"style_colorPanel__fQBLV","none":"style_none__gngs5"};